import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=4df60041&scoped=true"
import script from "./AccountManage.vue?vue&type=script&lang=js"
export * from "./AccountManage.vue?vue&type=script&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=4df60041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df60041",
  null
  
)

export default component.exports